import React from 'react';
import { Card } from 'primereact/card';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from 'react-router-dom';
import AboutUsContent from '../../shared/content/AboutUsContent';

const DashboardAboutUs = () => {
    const navigate = useNavigate();

    const breadcrumbItems = [
        { label: 'Dashboard', command: () => navigate('/app/dashboard') },
        { label: 'Company' },
        { label: 'About Us' }
    ];

    const home = { icon: 'pi pi-home', command: () => navigate('/app/dashboard') };

    return (
        <div className="surface-0">
            <div className="mb-3">
                <BreadCrumb model={breadcrumbItems} home={home} />
            </div>
            
            {/* Hero Section with Gradient - Same as public page */}
            <div className="relative overflow-hidden border-round-xl shadow-2 mb-5" style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                minHeight: '300px' 
            }}>
                <div className="absolute w-full h-full opacity-10">
                    <div className="absolute" style={{ 
                        top: '-10%', 
                        right: '-5%',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                    <div className="absolute" style={{ 
                        bottom: '-15%', 
                        left: '-5%',
                        width: '400px',
                        height: '400px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                </div>
                
                <div className="relative z-1 px-4 py-6 md:py-8 text-center text-white">
                    <h1 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">About Interestng</h1>
                    <p className="text-base md:text-lg opacity-80 px-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                        Transforming the lending industry through innovation and technology
                    </p>
                </div>
            </div>
            
            <Card className="border-0 shadow-2">
                <AboutUsContent showCTA={false} />
            </Card>
        </div>
    );
};

export default DashboardAboutUs;